module.exports = __webpack_public_path__ + "static/media/image1.0dd4f1b6.png";